module.exports = __webpack_public_path__ + "static/img/office_all_img.342a7e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office_all_img.jpg
// module id = PqUd
// module chunks = 1